'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));
var React = require('react');
var React__default = _interopDefault(React);
var R = require('ramda');
var __chunk_1 = require('./_virtual/_rollupPluginBabelHelpers.js');
var reactRouterDom = require('react-router-dom');

function isLocal(url) {
  // if url is an Object, it’s definitely for react-router
  if (R.is(Object, url)) {
    return true;
  } // if url is a Function, it’s also for react-router


  if (typeof url === 'function') {
    return true;
  } // if begins with protocol


  if (/^[a-z]+:\/\//.test(url)) {
    return false;
  } // if begins with double slash


  if (/^\/\//.test(url)) {
    return false;
  }

  return true;
} // --


function prependLocaleToPathname(locale, pathname) {
  if (locale && !/^\/?[a-z]{2}\W/i.test(pathname)) {
    return "/".concat(locale, "/").concat(pathname).replace('//', '/');
  }

  return pathname;
}
/**
 * Wrap location transformer function to prepend pathname with location when called
 * @param {Function} locationTransformer Function passed as `to` prop
 * @returns {Object}
 */


function enhanceLocationTransformer(locale, locationTransformer) {
  return R.pipe(R.defaultTo({}), locationTransformer, function (location) {
    return R.assoc('pathname', prependLocaleToPathname(locale, location.pathname), location);
  });
}

function prependLocale(locale, props) {
  var pathname = R.path(['to', 'pathname'], props) || R.prop('to', props);

  if (typeof props.to === 'function') {
    return R.assoc('to', enhanceLocationTransformer(locale, props.to), props);
  }

  var pathnameWithLocale = prependLocaleToPathname(locale, pathname);
  return R.is(String, props.to) ? R.assoc('to', pathnameWithLocale, props) : R.assocPath(['to', 'pathname'], pathnameWithLocale, props);
} // --

/**
 * Create react-router compatible Link capable to handle external URLs
 * @param {Object} props
 * @param {boolean} props.disabled Prevent browser click handling
 * @param {(Object|string)} props.to A location descriptor. See:
 * https://github.com/ReactTraining/react-router/blob/v3/docs/API.md#link
 * @return {ReactComponent}
 */


var Link =
/*#__PURE__*/
function (_React$PureComponent) {
  __chunk_1.inherits(Link, _React$PureComponent);

  function Link(props) {
    var _this;

    __chunk_1.classCallCheck(this, Link);

    _this = __chunk_1.possibleConstructorReturn(this, __chunk_1.getPrototypeOf(Link).call(this, props));
    _this.handleClick = _this.handleClick.bind(__chunk_1.assertThisInitialized(_this));
    return _this;
  }

  __chunk_1.createClass(Link, [{
    key: "handleClick",
    value: function handleClick(event) {
      if (this.props.disabled) {
        event.preventDefault();
      }

      if (typeof this.props.onClick === 'function') {
        this.props.onClick(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // if URL is not local, render regular <a>
      if (!isLocal(this.props.to)) {
        return React__default.createElement('a', R.merge({
          href: this.props.to,
          rel: 'noopener noreferrer',
          target: '_blank'
        }, R.omit(['to'], this.props)));
      } // stick in our click handler for disabled links to use preventDefault


      var props = R.assoc('onClick', this.handleClick, this.props); // fallback to react-router’s <Link> render

      return React__default.createElement(reactRouterDom.Link, prependLocale(this.context.locale, props));
    }
  }]);

  return Link;
}(React__default.PureComponent); // --

Link.contextTypes = {
  locale: PropTypes.string
};
Link.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  rel: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_parent', '_self', '_top']),
  to: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func
};

exports.Link = Link;
//# sourceMappingURL=link.js.map
